// Shared helpers for the ops pages.

export const formatDateTime = (iso: string): string =>
    new Date(iso).toLocaleString(undefined, {
        weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
    });

export const formatDate = (iso: string): string =>
    new Date(iso).toLocaleDateString(undefined, {weekday: 'short', month: 'short', day: 'numeric'});

// <input type="datetime-local"> wants local wall-clock time without a zone.
export const toLocalInput = (date: Date): string => {
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const fromLocalInput = (value: string): string => new Date(value).toISOString();

export const defaultReservationWindow = (): { startsAt: string; endsAt: string } => {
    const start = new Date();
    start.setDate(start.getDate() + 1);
    start.setHours(9, 0, 0, 0);
    const end = new Date(start);
    end.setDate(end.getDate() + 1);
    return {startsAt: toLocalInput(start), endsAt: toLocalInput(end)};
};

export const normalizeTag = (raw: string): string => raw.trim().toUpperCase();

// Short error/success tone for scan feedback; no audio assets needed.
export const beep = (ok: boolean) => {
    try {
        const ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = 'square';
        osc.frequency.value = ok ? 1200 : 220;
        gain.gain.value = 0.08;
        osc.connect(gain).connect(ctx.destination);
        osc.start();
        osc.stop(ctx.currentTime + (ok ? 0.08 : 0.35));
        osc.onended = () => ctx.close();
    } catch {
        // Audio is a nicety; never let it break a scan.
    }
};

export const statusLabel = (status: string): string => status.replace(/_/g, ' ');

export const statusClass: Record<string, string> = {
    REQUESTED: 'text-amber-300 border-amber-300/50',
    DRAFT: 'text-gray-400 border-gray-700',
    CONFIRMED: 'text-lumina-accent border-lumina-accent/40',
    PICKED: 'text-amber-400 border-amber-400/40',
    CHECKED_OUT: 'text-lumina-purple border-lumina-purple/40',
    RETURNED: 'text-emerald-400 border-emerald-400/40',
    CANCELLED: 'text-red-400 border-red-400/40',
};

export const inputClass =
    'bg-black border border-gray-800 px-3 py-2 text-sm focus:border-lumina-purple outline-none disabled:opacity-50';
export const buttonClass =
    'px-4 py-2 text-xs font-bold tracking-widest uppercase border transition-colors disabled:opacity-40 disabled:cursor-not-allowed';
export const primaryButton = `${buttonClass} bg-lumina-purple border-lumina-purple text-white hover:bg-lumina-purple/80`;
export const ghostButton = `${buttonClass} border-gray-700 text-gray-300 hover:border-lumina-accent hover:text-white`;
export const dangerButton = `${buttonClass} border-red-500/40 text-red-400 hover:bg-red-500/10`;
